import React, { useContext, useState } from 'react';
import {
  Button,
  FormField,
  StandardForm,
  TextInput,
  TextInputFloatingLabel,
  TextInputWithFloatingLabel,
} from '@vp/swan';
import PropTypes from 'prop-types';
import { InternalViewContext } from '../../contexts/InternalViewContext';
import useSiteData from '../../../hooks/useSiteData';

export const ActiveOrderControl = ({
  defaultOrderId,
  defaultLineItemId,
  defaultGroupId,
  collectLineItemId,
  collectGroupId,
}) => {
  const {
    internalViewerSuppliedShopperId,
    setInternalViewShopperId,
    setInternalViewOrderId,
    setInternalViewLineItemId,
    setInternalViewGroupId,
  } = useContext(InternalViewContext);

  const [shopperIdInput, setShopperIdInput] = useState(
    internalViewerSuppliedShopperId || ''
  );

  const [orderIdInput, setOrderIdInput] = useState(defaultOrderId || '');

  const [lineItemIdInput, setLineItemIdInput] = useState(
    defaultLineItemId || ''
  );

  const [groupIdInput, setGroupIdInput] = useState(defaultGroupId || '');

  const { uiData } = useSiteData();
  const isOrderDetails = !!(uiData.orderDetails || false);

  const loadShopperOrder = event => {
    event.preventDefault();
    setInternalViewShopperId({ shopperId: shopperIdInput });
    if (isOrderDetails) {
      setInternalViewOrderId({ newOrderId: orderIdInput });
    }
    if (collectLineItemId) {
      setInternalViewLineItemId({ newLineItemId: lineItemIdInput });
    }
    if (collectGroupId) {
      setInternalViewGroupId({ newGroupId: groupIdInput });
    }
  };

  const onShopperIdEntered = event => {
    setShopperIdInput(event.target.value.trim());
  };

  const onOrderIdEntered = event => {
    setOrderIdInput(event.target.value.trim());
  };

  const onLineItemIdEntered = event => {
    setLineItemIdInput(event.target.value.trim());
  };

  const onGroupIdEntered = event => {
    setGroupIdInput(event.target.value.trim());
  };

  return (
    <StandardForm>
      <FormField>
        <TextInputWithFloatingLabel>
          <TextInput
            id="shopper-id-entry-internal-view"
            onChange={onShopperIdEntered}
            value={shopperIdInput}
            mb={5}
            aria-required="true"
          />
          <TextInputFloatingLabel htmlFor="shopper-id-entry-internal-view">
            Enter a Shopper ID
          </TextInputFloatingLabel>
        </TextInputWithFloatingLabel>
      </FormField>
      {isOrderDetails && (
        <FormField>
          <TextInputWithFloatingLabel>
            <TextInput
              id="order-id-entry-internal-view"
              onChange={onOrderIdEntered}
              value={orderIdInput}
              mb={5}
              aria-required="true"
            />
            <TextInputFloatingLabel htmlFor="order-id-entry-internal-view">
              Enter an order ID
            </TextInputFloatingLabel>
          </TextInputWithFloatingLabel>
        </FormField>
      )}
      {collectLineItemId && (
        <FormField>
          <TextInputWithFloatingLabel>
            <TextInput
              id="line-item-id-entry-internal-view"
              onChange={onLineItemIdEntered}
              value={lineItemIdInput}
              mb={5}
              aria-required="true"
            />
            <TextInputFloatingLabel htmlFor="line-item-id-entry-internal-view">
              Enter a line item ID
            </TextInputFloatingLabel>
          </TextInputWithFloatingLabel>
        </FormField>
      )}
      {collectGroupId && (
        <FormField>
          <TextInputWithFloatingLabel>
            <TextInput
              id="group-id-entry-internal-view"
              onChange={onGroupIdEntered}
              value={groupIdInput}
              mb={5}
              aria-required="true"
            />
            <TextInputFloatingLabel htmlFor="group-id-entry-internal-view">
              Enter a group ID - feedback request
            </TextInputFloatingLabel>
          </TextInputWithFloatingLabel>
        </FormField>
      )}
      <Button
        skin="primary"
        width="full-width"
        onClick={event => loadShopperOrder(event)}
        type="submit"
      >
        Submit
      </Button>
    </StandardForm>
  );
};

ActiveOrderControl.propTypes = {
  defaultOrderId: PropTypes.string,
  defaultLineItemId: PropTypes.string,
  defaultGroupId: PropTypes.string,
  collectLineItemId: PropTypes.bool,
  collectGroupId: PropTypes.bool,
};
